module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007toc#chapter6"
    }
  }, [_vm._v("CRAFTING TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And finally, a few words to the wise to make your crafting go more efficiently:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Start with a prototype. A project doesn’t always work perfectly right out of the gate, so budget some time and extra materials for making a prototype first. This is especially true if you are inviting a group of friends over to crank out dozens of an item. Not all materials are created equally, so always test to make sure that the ones you’ve chosen behave the way you expect them to. For example, does your rubber-stamp ink bleed when stamped on your paper? (If so, the paper is too absorbent—try a different paper, or rub over the area to be stamped with a white pencil.) Does the card stock you purchased for your invitations feed through your printer?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Take your time. Haste makes waste, particularly when it comes to crafting materials, which can be expensive. Always take the time to double check your measurements (measure twice, cut once!). The key to a beautiful DIY wedding element is that it looks handmade yet also polished and refined. Work at a leisurely pace, paying attention to details, so that your project looks its best and is an accurate reflection of the time and energy that went into it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Have fun! Crafting is a wonderful escape from the mundane and abstract goings-on of day-to-day life. There’s simply nothing like making a beautiful object from scratch and seeing the tangible results of your efforts. Savor the experience, and share it with your friends!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93651e4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/014chapter6.vue
// module id = 90
// module chunks = 0